import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import useTranslation from "../../hooks/traslation";
import { GRAPH_TYPE } from "../../utils/enums";
import { useEffect, useState } from "react";
import { useLazyGetGraphQuery } from "../../services/analytics";
import { showError } from "../../constants/toasts";
// import "./earningGraph.css";

const EarningGraph = () => {
  const translation = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [graphType, setGraphType] = useState(GRAPH_TYPE.DAY);
  const [graphData] = useLazyGetGraphQuery();
  const [rows, setRows] = useState<
    Array<{ name: string; value: number; totalEarning: number }>
  >([]);

  const getGraphData: any = async () => {
    setIsLoading(true);
    try {
      const response = await graphData({
        type: graphType,
      }).unwrap();

      if (response?.statusCode === 200) {
        setIsLoading(false);
        setRows(response?.data || []);
      } else {
        setIsLoading(false);
        setRows([]);
      }
    } catch (error: any) {
      setIsLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const handleEmployeGraphTypeChange = (type: GRAPH_TYPE) => {
    setGraphType(type);
    // EmployeGraph();
  };
  useEffect(() => {
    getGraphData();
  }, [graphType]);
  return (
    <>
      <div className="cards table_card">
        <div className="cards_header">
          <div className="left_s">
            <h2>{translation.main.totalEarning}</h2>
          </div>
          <div className="right_s">
            <p>
              <span
                className={`time-period ${
                  graphType === GRAPH_TYPE.DAY ? "active" : ""
                }`}
                onClick={() => handleEmployeGraphTypeChange(GRAPH_TYPE.DAY)}
              >
                {translation.main.aday.charAt(0).toUpperCase() +
                  translation.main.aday.slice(1).toLowerCase()}
              </span>
              <span
                className={`time-period ${
                  graphType === GRAPH_TYPE.WEEK ? "active" : ""
                }`}
                onClick={() => handleEmployeGraphTypeChange(GRAPH_TYPE.WEEK)}
              >
                {translation.main.aweek.charAt(0).toUpperCase() +
                  translation.main.aweek.slice(1).toLowerCase()}
              </span>
              <span
                className={`time-period ${
                  graphType === GRAPH_TYPE.MONTH ? "active" : ""
                }`}
                onClick={() => handleEmployeGraphTypeChange(GRAPH_TYPE.MONTH)}
              >
                {translation.main.amonth.charAt(0).toUpperCase() +
                  translation.main.amonth.slice(1).toLowerCase()}
              </span>
              <span
                className={`time-period ${
                  graphType === GRAPH_TYPE.YEAR ? "active" : ""
                }`}
                onClick={() => handleEmployeGraphTypeChange(GRAPH_TYPE.YEAR)}
              >
                {translation.main.ayear.charAt(0).toUpperCase() +
                  translation.main.ayear.slice(1).toLowerCase()}
              </span>
            </p>
          </div>
        </div>
        <div className="graph-container">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={rows}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 60,
              }}
              style={{ fontSize: 15 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                angle={-45}
                textAnchor="end"
                height={60}
                interval={0}
                tick={{ fontSize: 12 }}
                tickFormatter={(value) => {
                  if (typeof value === "string") {
                    return (
                      value.charAt(0).toUpperCase() +
                      value.slice(1).toLowerCase()
                    );
                  }
                  return value;
                }}
              />
              <YAxis tick={{ fontSize: 10 }} width={80} />
              <Tooltip
                contentStyle={{
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              />
              <Bar
                dataKey="value"
                fill="#BF2F17"
                radius={[4, 4, 0, 0]}
                barSize={40}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
};

export default EarningGraph;
